import React from 'react';
import { useStyletron } from 'baseui';
import { Button, KIND as BUTTON_KIND, SIZE as BUTTON_SIZE } from 'baseui/button';
import { ActionButtonsRow } from '../styled-components';
export type AcceptIgnoreActionsProps = {
  onAccept?: () => void;
  onIgnore?: () => void;
  acceptLabel?: string;
  ignoreLabel?: string;
};
export const AcceptIgnoreActions = ({
  onAccept,
  onIgnore,
  acceptLabel = 'Accept',
  ignoreLabel = 'Ignore'
}: AcceptIgnoreActionsProps) => {
  const buttonOverrides = {
    BaseButton: {
      style: {
        flex: 1
      }
    }
  };
  return <ActionButtonsRow>
      {onIgnore && <Button kind={BUTTON_KIND.secondary} size={BUTTON_SIZE.xSmall} onClick={onIgnore} overrides={buttonOverrides} data-testid="ignore-button">
          {ignoreLabel}
        </Button>}
      {onAccept && <Button kind={BUTTON_KIND.primary} size={BUTTON_SIZE.xSmall} onClick={onAccept} overrides={buttonOverrides} data-testid="accept-button">
          {acceptLabel}
        </Button>}
    </ActionButtonsRow>;
};
export type NavigateButtonProps = {
  label: string;
  onNavigate: () => void;
};
export const NavigateButton = ({
  label,
  onNavigate
}: NavigateButtonProps) => {
  const [css, theme] = useStyletron();
  return <Button kind={BUTTON_KIND.primary} size={BUTTON_SIZE.xSmall} onClick={onNavigate} overrides={{
    BaseButton: {
      style: {
        backgroundColor: theme.colors.backgroundInversePrimary,
        marginTop: theme.sizing.scale200
      }
    }
  }}>
      <div className={css({
      ...theme.typography.LabelXSmall,
      color: theme.colors.contentInversePrimary
    })}>{`Go to ${label}`}</div>
    </Button>;
};